import { initSocketLive } from "@/components/utils/socket/socket";

const state = {
    socket: null,
    liveStatus: {},
};

const mutations = {
    setSocket(state, socket) {
        state.socket = socket;
    },
    updateLiveStatus(state, { id, status }) {
        state.liveStatus = { ...state.liveStatus, [id]: status };
    },

};

const actions = {
    initializeSocketLive({ commit }, id) {
        return initSocketLive(id, { commit });
    }
    };
    const getters = {
        getSocket: (state) => state.socket,
    }
    
export default {
    state,
    getters,
    mutations,
    actions,
};